export default __webpack_public_path__ + "static/media/image-cushion-r-w@3x.f350283f.png";